export const SIGNIN = 'signin'
export const OAUTH_SIGNIN = 'oauth-signin'
export const USER_ACCOUNT = 'user-account'
export const RESET_PASSWORD = 'reset-password'
export const RESET_PASSWORD_REQUEST = 'reset-password-request'
export const VERIFY = 'verify'
